var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / KN") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-KN",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    fill: "#1EC160",
    mask: "url(#mask-2)",
    points: "0 13.3333333 28 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    fill: "#DF2A40",
    mask: "url(#mask-2)",
    points: "0 20 28 20 28 6.66666667"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    fill: "#FFD956",
    mask: "url(#mask-2)",
    points: "0.78391906 25.3333944 33.5751121 4.8431828 27.2160809 -5.33339435 -5.57511211 15.1568172"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    fill: "#262626",
    mask: "url(#mask-2)",
    points: "-0.629198978 23.0719328 32.1619941 2.58172121 28.629199 -3.07193276 -4.16199407 17.4182788"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-29",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "20.3094011 7.79743495 19.3639918 9.2947928 18.7505603 7.63359418 17.0343408 7.19716559 18.4246738 6.10041889 18.3094011 4.33333333 19.7821057 5.31670522 21.4270827 4.66101488 20.9469312 6.36551882 22.0788556 7.72736546"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-29",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "9.64273441 14.2641098 8.69732517 15.7614676 8.0838936 14.100269 6.36767414 13.6638404 7.75800713 12.5670937 7.64273441 10.8000081 9.11543903 11.78338 10.760416 11.1276897 10.2802645 12.8321936 11.412189 14.1940403"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKn);
export default __webpack_public_path__ + "static/media/KN.fadf4c91278bde5941233463613258b1.svg";
export { ForwardRef as ReactComponent };